<script>
    import { updateAssetType } from '@/api/assetType.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_ASSET_TYPE_EDIT},
        },
        methods: {
            async save() {
                const data = this.$store.getters.ASSET_TYPE_DATA_EDIT;
                const response = await updateAssetType(data);
                if (response === true) {
                    const assetType = this.$store.getters.ASSET_TYPE_BY_NAME(data.name).id;
                    assetType.name = data.name,
                    assetType.description = data.description,
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_ASSET_TYPE_EDIT', false);
            }
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        @click="save"
        class="button_blue_100"
    >Save</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>